module.exports = __webpack_public_path__ + "static/media/goUpVector.44634449.svg";